// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"6f450e35","875":"db55deeb"}[chunkId] + ".chunk.css";
};